import script from "./FormSlugField.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSlugField.vue?vue&type=script&setup=true&lang=js"

import "./FormSlugField.vue?vue&type=style&index=0&id=775d08e9&lang=scss"

export default script